import lazyLoad from "common/utils/lazyLoad";
import { LoadingIndicator, Flex } from "@jsq/ds/core";
import React from "react";

export default lazyLoad(
  () => import(/* webpackChunkName: "BulkTransactionReviewPillar" */ "."),
  <Flex justifyContent="center" alignItems="center">
    <LoadingIndicator variant="primary" size="large" />
  </Flex>,
);
